import { styled } from "baseui";

export const ScreenHeader = styled("div", ({ $theme }) => ({
  ...$theme.typography.font1050,
  paddingLeft: "80px",
}));
